<template>
    <span style="white-space: pre-wrap;">
        <template v-for="each, i in str_arr" >
            <a v-if="each.indexOf('http') > -1" href="javascript:void(0);" :key="i" class="url_str" @click="showBrowser(each)">{{each}}</a>
            <template v-else>{{each}}</template>
        </template>
    </span>
</template>

<script>
    export default {
        name: "JoinChatContents",
        props : {
            contents : {
                type : String,
                default : '',
            }
        },
        data(){
            return {
                str_arr : []
            }
        },
        methods : {
            showBrowser(url){
                this.$Util.showBrowser(url);
            }
        },
        created(){
            const str_without_youtube = this.$Util.removeYoutubeLink(this.contents);
            const str_arr = str_without_youtube.split(/(https?:\/\/[^\s]+)/g).filter(item => item);
            this.str_arr = str_arr;
        }
    }
</script>

<style scoped>

</style>